import { memo } from "react";
import Button from "@mui/material/Button";
import { WebRoutes } from "consts/enpoints/web";
import { Link } from "infrastructure/router";
import Iconify from "lib/iconify";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { PspList } from "ui/organizms/PspKycSettings";

const AddKycButton = () => (
    <Button
        component={Link}
        to={WebRoutes.KYCSettings.PSPKYCSettings.New}
        variant='contained'
        startIcon={<Iconify icon='mdi:plus' />}
        data-test-id='pspKycSettings.add'
    >
        Add KYC
    </Button>
);

const PSPKYCSettings = (props: ScreenProps) => (
    <Screen
        {...props}
        title='KYC Settings | PSP KYC Settings'
    >
        <PspList
            title='PSP KYC Settings'
            heading='PSP KYC Settings'
            links={[]}
            Route={WebRoutes.KYCSettings.PSPKYCSettings}
            searchable
            pageSize={10}
            action={<AddKycButton />}
        />
    </Screen>
);

export default memo(PSPKYCSettings);
